import CartArticleRow from './CartArticleRow';

export default CartArticleRow;
